import React from "react";

const EnablePopupsGuide = () => {
  return (
    <div className="container mt-4">
      <div className="card shadow-sm">
        <div className="card-body">
          <h5 className="card-title text-primary mb-3">
            <i className="bi bi-info-circle-fill me-2"></i>
            How to Enable Pop-ups for This Site (Google Chrome)
          </h5>
          <ol className="list-group list-group-numbered">
            <li className="list-group-item">
              Click the ⁝ icon next to the website URL in the address bar.
            </li>
            <li className="list-group-item">
              Select <strong>"Site settings"</strong> from the dropdown menu.
            </li>
            <li className="list-group-item">
              Find the <strong>"Pop-ups and redirects"</strong> option.
            </li>
            <li className="list-group-item">
              Change the setting to <strong>"Allow"</strong>.
            </li>
            <li className="list-group-item">
              Close the settings tab and refresh the page.
            </li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default EnablePopupsGuide;
